/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/breachesMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a Breaches. */
export class Breaches {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a Breaches.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Start dark web scanning on behalf of the current user. If fullScan is set true all found new
   * breaches are return by the API.Else response is filtered based on the provided breach entity
   * value and breach type except for SSN where filtering is only applied on SSN type.
   * @summary Start dark web scanning for the current user
   * @param [options] The optional parameters
   * @returns Promise<Models.BreachesScanAndGetBreachesResponse>
   */
  scanAndGetBreaches(options?: Models.BreachesScanAndGetBreachesOptionalParams): Promise<Models.BreachesScanAndGetBreachesResponse>;
  /**
   * @param callback The callback
   */
  scanAndGetBreaches(callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  scanAndGetBreaches(options: Models.BreachesScanAndGetBreachesOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  scanAndGetBreaches(options?: Models.BreachesScanAndGetBreachesOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.BreachesScanAndGetBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      scanAndGetBreachesOperationSpec,
      callback) as Promise<Models.BreachesScanAndGetBreachesResponse>;
  }

  /**
   * Update the state of composite or single breach entity state given breach id, entityId and the
   * type of data field
   * @summary Update the state of breach entity or data field
   * @param breachId
   * @param entityId
   * @param [options] The optional parameters
   * @deprecated This operation is deprecated. Please do not use it any longer.
   * @returns Promise<Models.BreachesUpdateBreachEntityStateResponse>
   */
  updateBreachEntityState(breachId: string, entityId: string, options?: Models.BreachesUpdateBreachEntityStateOptionalParams): Promise<Models.BreachesUpdateBreachEntityStateResponse>;
  /**
   * @param breachId
   * @param entityId
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  updateBreachEntityState(breachId: string, entityId: string, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>): void;
  /**
   * @param breachId
   * @param entityId
   * @param options The optional parameters
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  updateBreachEntityState(breachId: string, entityId: string, options: Models.BreachesUpdateBreachEntityStateOptionalParams, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>): void;
  updateBreachEntityState(breachId: string, entityId: string, options?: Models.BreachesUpdateBreachEntityStateOptionalParams | coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>, callback?: coreHttp.ServiceCallback<Models.IdentityMonitoringBreach>): Promise<Models.BreachesUpdateBreachEntityStateResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        entityId,
        options
      },
      updateBreachEntityStateOperationSpec,
      callback) as Promise<Models.BreachesUpdateBreachEntityStateResponse>;
  }

  /**
   * Update in batch the state of multiple breach entities or data fields using the given breach Id
   * and a list entityId
   * @summary Batch update the state of breach entities or data fields
   * @param breachId
   * @param [options] The optional parameters
   * @returns Promise<Models.BreachesBatchUpdateBreachEntityStateResponse>
   */
  batchUpdateBreachEntityState(breachId: string, options?: Models.BreachesBatchUpdateBreachEntityStateOptionalParams): Promise<Models.BreachesBatchUpdateBreachEntityStateResponse>;
  /**
   * @param breachId
   * @param callback The callback
   */
  batchUpdateBreachEntityState(breachId: string, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>): void;
  /**
   * @param breachId
   * @param options The optional parameters
   * @param callback The callback
   */
  batchUpdateBreachEntityState(breachId: string, options: Models.BreachesBatchUpdateBreachEntityStateOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>): void;
  batchUpdateBreachEntityState(breachId: string, options?: Models.BreachesBatchUpdateBreachEntityStateOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>, callback?: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues>): Promise<Models.BreachesBatchUpdateBreachEntityStateResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        options
      },
      batchUpdateBreachEntityStateOperationSpec,
      callback) as Promise<Models.BreachesBatchUpdateBreachEntityStateResponse>;
  }

  /**
   * Currently supports only updating state to New/Remediated, which updates the states of the
   * underlying entities to remediated or new based on the request.
   * @summary Batch patch breaches
   * @param [options] The optional parameters
   * @returns Promise<Models.BreachesPatchBreachesResponse>
   */
  patchBreaches(options?: Models.BreachesPatchBreachesOptionalParams): Promise<Models.BreachesPatchBreachesResponse>;
  /**
   * @param callback The callback
   */
  patchBreaches(callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  patchBreaches(options: Models.BreachesPatchBreachesOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>): void;
  patchBreaches(options?: Models.BreachesPatchBreachesOptionalParams | coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetailWithoutValues[]>): Promise<Models.BreachesPatchBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      patchBreachesOperationSpec,
      callback) as Promise<Models.BreachesPatchBreachesResponse>;
  }

  /**
   * Get all existing breaches for the current user.
   * @summary Get all breaches for the current user.
   * @param [options] The optional parameters
   * @returns Promise<Models.BreachesGetBreachesResponse>
   */
  getBreaches(options?: coreHttp.RequestOptionsBase): Promise<Models.BreachesGetBreachesResponse>;
  /**
   * @param callback The callback
   */
  getBreaches(callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getBreaches(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BreachedDetail[]>): void;
  getBreaches(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BreachedDetail[]>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail[]>): Promise<Models.BreachesGetBreachesResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getBreachesOperationSpec,
      callback) as Promise<Models.BreachesGetBreachesResponse>;
  }

  /**
   * Get the specified breach for the current user through the provided breachId.
   * @summary Get the specified breach for the current user.
   * @param breachId
   * @param [options] The optional parameters
   * @returns Promise<Models.BreachesGetBreachByIdResponse>
   */
  getBreachById(breachId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.BreachesGetBreachByIdResponse>;
  /**
   * @param breachId
   * @param callback The callback
   */
  getBreachById(breachId: string, callback: coreHttp.ServiceCallback<Models.BreachedDetail>): void;
  /**
   * @param breachId
   * @param options The optional parameters
   * @param callback The callback
   */
  getBreachById(breachId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.BreachedDetail>): void;
  getBreachById(breachId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.BreachedDetail>, callback?: coreHttp.ServiceCallback<Models.BreachedDetail>): Promise<Models.BreachesGetBreachByIdResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        options
      },
      getBreachByIdOperationSpec,
      callback) as Promise<Models.BreachesGetBreachByIdResponse>;
  }

  /**
   * Mark a recommendation as completed by setting the isCompleted flag of the recommendation to
   * true.
   * @summary Complete a recommendation.
   * @param breachId
   * @param entityId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param [options] The optional parameters
   * @deprecated This operation is deprecated. Please do not use it any longer.
   * @returns Promise<Models.BreachesCompleteRecommendationResponse>
   */
  completeRecommendation(breachId: string, entityId: string, recommendationId: Models.RecommendationId, options?: Models.BreachesCompleteRecommendationOptionalParams): Promise<Models.BreachesCompleteRecommendationResponse>;
  /**
   * @param breachId
   * @param entityId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  completeRecommendation(breachId: string, entityId: string, recommendationId: Models.RecommendationId, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>): void;
  /**
   * @param breachId
   * @param entityId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param options The optional parameters
   * @param callback The callback
   * @deprecated This operation is deprecated. Please do not use it any longer.
   */
  completeRecommendation(breachId: string, entityId: string, recommendationId: Models.RecommendationId, options: Models.BreachesCompleteRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>): void;
  completeRecommendation(breachId: string, entityId: string, recommendationId: Models.RecommendationId, options?: Models.BreachesCompleteRecommendationOptionalParams | coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>, callback?: coreHttp.ServiceCallback<Models.IdentityMonitoringRecommendation>): Promise<Models.BreachesCompleteRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        entityId,
        recommendationId,
        options
      },
      completeRecommendationOperationSpec,
      callback) as Promise<Models.BreachesCompleteRecommendationResponse>;
  }

  /**
   * Mark recommendation(s) as in/complete by setting {isCompleted} of the recommendations.
   * @summary Update states of recommendations of {recommendationId} in breach.
   * @param breachId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param [options] The optional parameters
   * @returns Promise<Models.BreachesCompleteBreachRecommendationResponse>
   */
  completeBreachRecommendation(breachId: string, recommendationId: Models.RecommendationId, options?: Models.BreachesCompleteBreachRecommendationOptionalParams): Promise<Models.BreachesCompleteBreachRecommendationResponse>;
  /**
   * @param breachId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param callback The callback
   */
  completeBreachRecommendation(breachId: string, recommendationId: Models.RecommendationId, callback: coreHttp.ServiceCallback<Models.BreachRecommendation>): void;
  /**
   * @param breachId
   * @param recommendationId Possible values include: 'EnableMFA', 'ChangeSharedPasswords',
   * 'ContactRestorationServices', 'ChangePassword', 'CheckUnfamiliarTransactionsBank',
   * 'CheckUnfamiliarTransactionsCreditCard', 'CheckUnfamiliarTransactionsEbay',
   * 'CheckUnfamiliarClaims', 'ChangeSecurityQuestionsMothersName', 'SelectNewPinBank',
   * 'RequestNewCard', 'RequestNewCardRetailCard', 'SelectNewPinCreditCard',
   * 'ChangeSecurityQuestionsBirthday', 'ReviewCreditReports', 'ReportStolenNationalId',
   * 'ReportStolenPassport', 'CheckUnfamiliarTransactionsPayPal',
   * 'CheckUnfamiliarTransactionsRetail', 'ReportIdTheft', 'PlaceCreditFreeze',
   * 'UpdateAutomaticPayments', 'ContactPhoneProvider', 'DotNotCall', 'EnableMFABank',
   * 'EnableMFABankPassword', 'EnableMFAEbay', 'EnableMFAPaypal',
   * 'ReviewCreditReportsAndContactRestorationServices', 'ChangePasswordAndUsePasswordManager',
   * 'ChangeSharedPasswordsWithExplanation'
   * @param options The optional parameters
   * @param callback The callback
   */
  completeBreachRecommendation(breachId: string, recommendationId: Models.RecommendationId, options: Models.BreachesCompleteBreachRecommendationOptionalParams, callback: coreHttp.ServiceCallback<Models.BreachRecommendation>): void;
  completeBreachRecommendation(breachId: string, recommendationId: Models.RecommendationId, options?: Models.BreachesCompleteBreachRecommendationOptionalParams | coreHttp.ServiceCallback<Models.BreachRecommendation>, callback?: coreHttp.ServiceCallback<Models.BreachRecommendation>): Promise<Models.BreachesCompleteBreachRecommendationResponse> {
    return this.client.sendOperationRequest(
      {
        breachId,
        recommendationId,
        options
      },
      completeBreachRecommendationOperationSpec,
      callback) as Promise<Models.BreachesCompleteBreachRecommendationResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const scanAndGetBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/Breaches/scan",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ScanRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const updateBreachEntityStateOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Breaches/{breachId}/{entityId}",
  urlParameters: [
    Parameters.breachId,
    Parameters.entityId
  ],
  queryParameters: [
    Parameters.breachedType,
    Parameters.state
  ],
  responses: {
    200: {
      bodyMapper: Mappers.IdentityMonitoringBreach
    },
    404: {
      bodyMapper: Mappers.IdentityMonitoringBreach
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const batchUpdateBreachEntityStateOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Breaches/{breachId}/entities",
  urlParameters: [
    Parameters.breachId
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UpdateDatafieldBatchRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.BreachedDetailWithoutValues
    },
    404: {
      bodyMapper: Mappers.BreachedDetailWithoutValues
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const patchBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Breaches",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PatchBreachesRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetailWithoutValues"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getBreachesOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Breaches",
  responses: {
    200: {
      bodyMapper: {
        serializedName: "parsedResponse",
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "BreachedDetail"
            }
          }
        }
      }
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getBreachByIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/IdentityTheftMonitoring/Breaches/{breachId}",
  urlParameters: [
    Parameters.breachId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.BreachedDetail
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const completeRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Breaches/{breachId}/{entityId}/{recommendationId}",
  urlParameters: [
    Parameters.breachId,
    Parameters.entityId,
    Parameters.recommendationId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ResolveRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.IdentityMonitoringRecommendation
    },
    404: {
      bodyMapper: Mappers.IdentityMonitoringRecommendation
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const completeBreachRecommendationOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/IdentityTheftMonitoring/Breaches/{breachId}/recommendation/{recommendationId}",
  urlParameters: [
    Parameters.breachId,
    Parameters.recommendationId0
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.ResolveRecommendationRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {
      bodyMapper: Mappers.BreachRecommendation
    },
    404: {
      bodyMapper: Mappers.BreachRecommendation
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
